import { ReactNode } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import {
    MdDeliveryDining,
    MdOutlineDashboard,
    MdOutlineDeliveryDining,
    MdOutlineFeaturedPlayList,
} from "react-icons/md";
import { RiLogoutCircleLine } from "react-icons/ri";
import {
    BsChevronDown,
    BsChevronUp,
    BsFillBoxSeamFill,
    BsPerson,
} from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
    logout,
    selectActiveDropDown,
    selectActiveDropDownTab,
    selectActiveTab,
    selectAuth,
    selectCollapsedSidebar,
    setActiveDropDown,
    setActiveDropDownTab,
    setActiveTab,
    setCollapseSidebar,
} from "../redux/features/authSlice";
import { useGetProfileQuery } from "../redux/api/profileApi/profileApi";
import { useNavigate } from "react-router-dom";
import { IAuthUser } from "../redux/features/authSlice/authSlice.types";
import jwt_decode from "jwt-decode";
import { AiOutlinePullRequest } from "react-icons/ai";
import { TbTruckDelivery, TbTruckReturn } from "react-icons/tb";
import { PiKeyReturnFill, PiKeyReturnLight } from "react-icons/pi";

interface SidebarItem {
    id: number;
    title: string;
    path: string;
    icon: ReactNode;
    isDropdown: boolean;
    dropdownItems?: DropdownItem[];
    dropdownIcons?: {
        up: ReactNode;
        down: ReactNode;
    };
}

interface DropdownItem {
    id: number;
    title: string;
    path: string;
    icon: ReactNode;
    isDropdown: boolean;
}

const sidebarItem: SidebarItem[] = [
    {
        id: 1,
        title: "Dashboard",
        path: "/",
        icon: <MdOutlineDashboard />,
        isDropdown: false,
    },
    {
        id: 2,
        title: "Pickup Parcel",
        path: "/pickup-parcel",
        icon: <BsFillBoxSeamFill />,
        isDropdown: true,
        dropdownItems: [
            {
                id: 21,
                title: "Pickup Parcel List",
                path: "/pickup-parcel-list",
                icon: <MdOutlineFeaturedPlayList />,
                isDropdown: false,
            },
            {
                id: 22,
                title: "Pickup Request List",
                path: "/pickup-request-list",
                icon: <AiOutlinePullRequest />,
                isDropdown: false,
            },
        ],
        dropdownIcons: {
            down: <BsChevronDown />,
            up: <BsChevronUp />,
        },
    },
    {
        id: 3,
        title: "Delivery Parcel",
        path: "/delivery-parcel",
        icon: <TbTruckDelivery />,
        isDropdown: true,
        dropdownItems: [
            {
                id: 31,
                title: "Delivery Parcel List",
                path: "/delivery-parcel-list",
                icon: <MdDeliveryDining />,
                isDropdown: false,
            },
            {
                id: 32,
                title: "Delivery Completed List",
                path: "/delivery-completed-list",
                icon: <MdOutlineDeliveryDining />,
                isDropdown: false,
            },
        ],
        dropdownIcons: {
            down: <BsChevronDown />,
            up: <BsChevronUp />,
        },
    },
    {
        id: 4,
        title: "Return Parcel",
        path: "/return-parcel",
        icon: <TbTruckReturn />,
        isDropdown: true,
        dropdownItems: [
            {
                id: 41,
                title: "Return Parcel List",
                path: "/return-parcel-list",
                icon: <PiKeyReturnFill />,
                isDropdown: false,
            },
            {
                id: 42,
                title: "Return Completed List",
                path: "/return-completed-list",
                icon: <PiKeyReturnLight />,
                isDropdown: false,
            },
        ],
        dropdownIcons: {
            down: <BsChevronDown />,
            up: <BsChevronUp />,
        },
    },
    {
        id: 5,
        title: "Profile",
        path: "/profile",
        icon: <BsPerson />,
        isDropdown: false,
    },
];

const CustomSidebar = () => {
    const dispatch = useDispatch();
    const activeTab = useSelector(selectActiveTab);
    const activeDropDownTab = useSelector(selectActiveDropDownTab);
    const activeDropDown = useSelector(selectActiveDropDown);
    const collapsedSidebar = useSelector(selectCollapsedSidebar);
    const { token } = useSelector(selectAuth);
    const authData: IAuthUser = token ? jwt_decode(token) : null;
    const { data: profileData, isSuccess } = useGetProfileQuery(authData?.id);
    const navigate = useNavigate();

    console.log(profileData)

    return (
        <div
            className={`bg-white ${collapsedSidebar ? "w-auto" : "w-[350px]"
                } transition-all h-[100vh] p-6 flex justify-between  flex-col sticky top-0 overflow-x-auto`}
            style={{
                boxShadow: "-5px 0px 20px 0px #d1edff",
            }}
        >
            <div className="">
                <div className="flex gap-3 text-xl font-bold items-center text-text_1 p-3">
                    <div
                        onClick={() => dispatch(setCollapseSidebar(!collapsedSidebar))}
                        className="bg-primary p-1 rounded text-white cursor-pointer hover:scale-105 transition-all shadow"
                    >
                        <GiHamburgerMenu />
                    </div>
                    {collapsedSidebar ? "" : "Rider."}
                </div>
                <div className="flex flex-col gap-1 mt-4 overflow-x-auto">
                    {sidebarItem?.map((item, index) => {
                        return (
                            <div key={index}>
                                <div
                                    onClick={() => {
                                        if (!item?.isDropdown) {
                                            dispatch(setActiveTab(item?.title));
                                            navigate(item?.path);
                                            dispatch(setActiveDropDown(null));
                                            dispatch(setActiveDropDownTab(""));
                                        } else {
                                            dispatch(setActiveTab(item?.title));
                                            dispatch(
                                                setActiveDropDown(
                                                    activeDropDown === null
                                                        ? item?.id
                                                        : activeDropDown === item?.id
                                                            ? null
                                                            : item?.id
                                                )
                                            );
                                        }
                                    }}
                                    className={`text-lg flex items-center text-text_3 font-bold p-3 rounded w-full justify-between hover:bg-primary/10 cursor-pointer transition-all hover:text-primary ${activeTab === item?.title ||
                                        item?.dropdownItems?.filter(
                                            (subItem) => subItem?.title === activeTab
                                        )?.length > 0
                                        ? "bg-primary/10 !text-primary"
                                        : ""
                                        }`}
                                >
                                    <div className="flex gap-3 items-center">
                                        <div className="text-2xl">{item?.icon}</div>
                                        {!collapsedSidebar && item?.title}
                                    </div>
                                    {!collapsedSidebar &&
                                        (item?.isDropdown && activeDropDown === item?.id
                                            ? item?.dropdownIcons?.up
                                            : item?.dropdownIcons?.down)}
                                </div>
                                {activeDropDown === item?.id && (
                                    <div className="ml-5 my-2">
                                        {item?.dropdownItems?.map((subItem, ind) => {
                                            return (
                                                <div
                                                    key={ind}
                                                    onClick={() => {
                                                        dispatch(setActiveDropDownTab(subItem?.title));
                                                        navigate(subItem?.path);
                                                    }}
                                                    className={`text-lg flex items-center text-text_3 font-bold p-3 my-1 rounded w-full justify-between hover:bg-primary/10 cursor-pointer transition-all hover:text-primary ${activeDropDownTab === subItem?.title
                                                        ? "bg-primary/10 !text-primary"
                                                        : ""
                                                        }`}
                                                >
                                                    <div className="flex gap-3 items-center">
                                                        <div className="text-2xl">{subItem?.icon}</div>
                                                        {!collapsedSidebar && subItem?.title}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div>
                <div
                    onClick={() => dispatch(logout())}
                    className="bg-primary text-white text-lg flex items-center justify-center p-2 rounded shadow font-bold gap-3 text-center cursor-pointer hover:animate-pulse"
                >
                    <RiLogoutCircleLine />
                    {collapsedSidebar ? "" : "Logout"}
                </div>
                {isSuccess && (
                    <div onClick={() => {
                        dispatch(setActiveTab('Profile'))
                        navigate('/profile');
                    }} className="flex gap-4 items-center mt-4 cursor-pointer">
                        <div className="overflow-hidden rounded-full border-2">
                            <img
                                src={
                                    profileData?.image || "https://i.ibb.co/8MgR8kC/images.png"
                                }
                                className="h-10 w-10 rounded-full"
                                alt="profile"
                            />
                        </div>
                        {!collapsedSidebar && (
                            <div>
                                <div className="text-lg text-text_2">{profileData?.name}</div>
                                <div className="text-sm text-text_3">{profileData?.email}</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomSidebar;
